import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Get } from "libs/services";
import { ITEM } from "libs/config";
import { setLoading } from "./loader";
import { CATEGORIES } from "src/common/libs/config/categories.config";
import { BaseResponse } from "src/common/types/response/BasePaginationResponse";
import { CategoryPayload } from "src/common/types/response/categories";
import { reportLog } from "src/common/libs/utils/logs";

interface CategoryState {
  categories: Array<CategoryPayload>;
  loading: boolean
}

export const getCategories = createAsyncThunk(
  "categories/getCategories",
  async (query: {}, thunkAPI) => {
    try {
      const response = await Get<BaseResponse<CategoryPayload>>(
        CATEGORIES.get,
        query
      );
      return response.data.payload as Array<CategoryPayload>;
    } catch (error) {
      reportLog({
        error: error,
        location: "features/categories->getCategories[24]",
        body: { query },
      });
      return null;
    } finally {
    }
  }
);

const initialState: CategoryState = {
  categories: [],
  loading: true
};

export const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCategories.pending, (state, action) => {
      state.loading = true
    });
    builder.addCase(getCategories.fulfilled, (state, action) => {
      state.categories = action.payload;
      state.loading = false
    });
    builder.addCase(getCategories.rejected, (state, action) => {
      state.categories = [];
      state.loading = false
    });
  },
});

export const {} = categorySlice.actions;

export default categorySlice.reducer;
